//
// Generated class ChangelogCommitted
//

/// <reference path="ChangelogCommitted_ManagedObject.ts" />

class ChangelogCommitted extends ChangelogCommitted_ManagedObject
{

}
